module.exports = __webpack_public_path__ + "static/who-we-are-hero-e41cb8fc5b8c59463f03599425ab143f.svg";